<template>
  <div id="app">
    <TimerModal></TimerModal>
    <router-view />
  </div>
</template>

<script>
import TimerModal from "./components/TimerModal.vue";
export default {
  components: {
    TimerModal,
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2b303a;
}

.column {
  display: flex;
  flex-direction: column;
}

.collection {
  #line {
    border: 2px solid transparent;
  }
  .card {
    border: solid #fff 2px;
    border-radius: 3px;
    transition: 0.2s;

    &:hover {
      border: #2b303a solid 2px;
      border-radius: 3px;
    }
  }
}
</style>
